import { render, staticRenderFns } from "./offline_payment_checkout.vue?vue&type=template&id=2ea8a2ca&scoped=true&"
import script from "./offline_payment_checkout.vue?vue&type=script&lang=js&"
export * from "./offline_payment_checkout.vue?vue&type=script&lang=js&"
import style0 from "./offline_payment_checkout.vue?vue&type=style&index=0&id=2ea8a2ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea8a2ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
